import React from "react";

import "./TooltipOptions.css";
import { Col, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNotdef } from "@fortawesome/free-solid-svg-icons";

function TooltipOptions({
  icon = faNotdef,
  title,
  endSecion = false,
  ...props
}) {
  return (
    <>
      <Col
        {...props}
        span={24}
        className={`conversationSettingWrapper ${
          endSecion && "endConversationSection"
        }`}
        onClick={(event) => {
          event.stopPropagation(); // Ngăn sự kiện lan ra ngoài
          if (props.onClick) {
            props.onClick(event);
          }
        }}
      >
        <Row>
          <Col span={3} className="conversationSettingIcon">
            <FontAwesomeIcon icon={icon} />
          </Col>
          <Col span={21}>
            <span className="conversationSettingTitle">{title}</span>
          </Col>
        </Row>
      </Col>
    </>
  );
}

export default TooltipOptions;
